module.exports = __webpack_public_path__ + "img/es-ct.d045e295.svg";